"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DisponibilitLocale() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const stats = [{
    label: "DÉLAI MOYEN 2-4 HEURES"
  }, {
    label: "DIAGNOSTIC PRÉCIS INCLUS"
  }, {
    label: "GARANTIE SUR TOUS LES TRAVAUX"
  }];
  return <section data-section-id="3995" id="disponibilité-locale" className="relative bg-background text-foreground overflow-hidden min-h-[80vh] flex items-center justify-center px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_inspection_camera_view.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/85 via-background/75 to-background/90" aria-hidden="true" />

      {}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: "radial-gradient(circle, var(--primary) 1px, transparent 1px)",
      backgroundSize: "24px 24px"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]" style={{
      backgroundImage: "repeating-linear-gradient(0deg, var(--muted-foreground) 0px, var(--muted-foreground) 1px, transparent 1px, transparent 3px)"
    }} aria-hidden="true" />

      {}
      {}
      <div className="absolute top-6 left-6 sm:top-8 sm:left-8 flex items-center gap-2 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-primary z-10">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75" />
          <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary" />
        </span>
        <span>STATUT: DISPONIBLE</span>
      </div>

      {}
      <div className="absolute top-6 right-6 sm:top-8 sm:right-8 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-muted-foreground z-10 text-right">
        <div>45.5017° N</div>
        <div>73.5673° W</div>
      </div>

      {}
      <div className="hidden sm:block absolute bottom-8 left-6 lg:left-8 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground z-10" style={{
      writingMode: "vertical-rl",
      transform: "rotate(180deg)"
    }}>
        OT SOLUTION // OPÉRATIONS
      </div>

      {}
      <div className="absolute bottom-6 right-6 sm:bottom-8 sm:right-8 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-muted-foreground z-10">
        // 05 — MONTRÉAL
      </div>

      {}
      <div ref={ref} className={`relative z-10 max-w-6xl w-full mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="mb-6 flex items-center justify-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-primary">
          <span className="h-px w-8 bg-primary" />
          <span>// [01] DÉBOUCHAGE</span>
          <span className="h-px w-8 bg-primary" />
        </div>

        {}
        <h2 className="font-default uppercase font-bold leading-[0.9] tracking-tight text-foreground" style={{
        fontSize: "clamp(3.5rem, 12vw, 10rem)"
      }}>
          DRAIN BLOQUÉ
          <span className="text-secondary">?</span>
        </h2>

        {}
        <p className="mt-8 text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto font-default">
          Expertise chirurgicale en drainage. À partir de 275$. Votre mission de débouchage commence ici.
        </p>

        {}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono uppercase tracking-widest text-sm px-8 h-14 rounded-md shadow-md">
            <Link to="/ContactPage">
              [ RÉSERVER INSPECTION
              <ArrowRight className="ml-1 size-4" />
              ]
            </Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="border-secondary bg-secondary text-secondary-foreground hover:bg-secondary/90 font-mono uppercase tracking-widest text-sm px-8 h-14 rounded-md shadow-lg">
            <Link to="tel:+14383678309">
              <Phone className="size-4" />
              438-367-8309
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-4 gap-y-3 font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-muted-foreground">
          {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-x-4">
              {i > 0 && <span className="text-primary select-none" aria-hidden="true">
                  +
                </span>}
              <span>{stat.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}